app.service('menuBar', function(menu, searchBox) {
	function setEvents() {
		$('#hamburger')
			.on('click', menu.open)
			.on('keyup', function(e) {
				if (e.keyCode === 13) { // Enter key
					menu.open();
				}
			});
		$('#product-menu').on('click', menu.open);
		$('#search-menu').on('click keyup', function(e) {
			if (e.type === 'click' || e.type === 'keyup' && (e.keyCode === 13 || e.keyCode === 32)) {
				searchBox.open();
			}
		})
	}

	function init() {
		setEvents();
	}

	return {
		init
	};
});
